<template>
  <base-icon name="fa6-solid:circle-exclamation" size="12px" class="mr-1" />
</template>
